import filterByProfessional from './filterByProfessional'

export default (searchedBy, filters, agenda, covenant, level, user) => {
  filterByProfessional(searchedBy, filters, agenda)
}



// WEBPACK FOOTER //
// ./src/app/patient/favorite-list/resources/filters/index.js